import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
// import Tooltip from '@material-ui/core/Tooltip';
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";

import { calcPrice } from "../actions";
import MySnackbar from './MySnackbar'

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit
  },
  buttonAddCart: {
    fontWeight: "bold",
    // backgroundColor:"#c7000b",
    backgroundColor: "#EE220C",
    "&:hover": {
      backgroundColor: "#a21607"
    }
  },
  tooltipButton: {
    minHeight: 0,
    padding: 0,
    mrgin: 0,
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  popover: {
    pointerEvents: "none"
  },
  paper: {
    padding: theme.spacing.unit
  }
});
class Cart extends Component {
  state = {
    anchorEl: null
  };
  // componentDidMount() {
  //     // this.props.readTest()
  // }
  handlePopoverOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    const { classes, cart } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const formatter = new Intl.NumberFormat("ja-JP");
		const date = new Date();
    let note_text = "";
    if ("minPost" in cart.estimate && cart.estimate.minPost.flg) {
      note_text =
        formatter.format(cart.estimate.minPost.num) +
        "部未満の配布は別途基本料金がかかります。";
    }
    return (
      <div className="CartComponent">
        <Paper className={classes.root} elevation={1}>
          <table className="cartTable">
            <tbody>
              <tr>
                <th className="cartTitleCol">
                  <span>配布料金（税別）</span>
                </th>
                <td className="cartValueCol">
                  <span>
                    {"postPrice" in cart.estimate
                      ? formatter.format(cart.estimate.postPrice)
                      : "？"}
                    円
                  </span>
                </td>
              </tr>
              {"minPost" in cart.estimate && cart.estimate.minPost.flg ? (
                <tr>
                  <th className="cartTitleCol">
                    <span>
                      <Typography
                        aria-owns={open ? "cart-mouse-over-popover" : null}
                        aria-haspopup="true"
                        onMouseEnter={this.handlePopoverOpen}
                        onMouseLeave={this.handlePopoverClose}
                      >
                        配布基本料金
                      </Typography>
                      <Popover
                        id="cart-mouse-over-popover"
                        className={classes.popover}
                        classes={{
                          paper: classes.paper
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left"
                        }}
                        onClose={this.handlePopoverClose}
                        disableRestoreFocus
                      >
                        {note_text}
                      </Popover>
                    </span>
                  </th>
                  <td className="cartValueCol">
                    <span>
                      {formatter.format(cart.estimate.minPost.price)}円
                    </span>
                  </td>
                </tr>
              ) : null}
              <tr>
                <th className="cartTitleCol">
                  <span>配布単価</span>
                </th>
                <td className="cartValueCol">
                  <span>
                    1部＠
                    {"postUnitPrice" in cart.estimate
                      ? cart.estimate.postUnitPrice
                      : "？"}
                    円
                  </span>
                </td>
              </tr>
              {"printPrice" in cart.estimate ? (
                <tr>
                  <th className="cartTitleCol">
                    <span>印刷料金（税別）</span>
                  </th>
                  <td className="cartValueCol">
                    <span>{formatter.format(cart.estimate.printPrice)}円</span>
                  </td>
                </tr>
              ) : null}
              <tr className="totalPrice">
                <th className="cartTitleCol">
                  <span>合計（税別）</span>
                </th>
                <td className="cartValueCol">
                  <span>
                    {"totalPrice" in cart.estimate
                      ? formatter.format(cart.estimate.totalPrice)
                      : "？"}
                    円
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonAddCart}
            fullWidth={true}
            disabled={
              Object.keys(cart.error).length || !("totalPriceTax" in cart.estimate)
            }
            onClick={this.props.calcPrice}
          >
            カゴに入れる
          </Button>
        </Paper>
				{ 'error' in cart && 'alert' in cart.error ? (
          <MySnackbar
            key={date.getTime()}
            variant="error"
            message={cart.error.alert}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cart: state.cart
});

const mapDispatchToProps = dispatch => ({
  calcPrice: () => dispatch(calcPrice(true))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Cart));



// WEBPACK FOOTER //
// ./src/components/Cart.js